import * as Yup from 'yup';
import {checkIfTypeStartsWithPreOrPostSessionFirstDigit, FormNameEnum} from 'filters-selections';
import {audienceStudentId, errorMessages, typeFeedbackId} from 'utils';

export const createInstrumentValidationSchema = Yup.object().shape({
  [FormNameEnum.instrumentName]: Yup.string().trim().required(errorMessages.instrumentNameRequired),
  [FormNameEnum.pillars]: Yup.number()
    .nullable()
    .when(FormNameEnum.isGeneralInstrument, {
      is: true,
      then: Yup.number().notRequired(),
      otherwise: Yup.number().nullable().required(errorMessages.pillarRequired),
    }),
  [FormNameEnum.instrumentType]: Yup.number()
    .nullable()
    .when(FormNameEnum.isGeneralInstrument, {
      is: true,
      then: Yup.number(),
      otherwise: Yup.number().nullable().required(errorMessages.instrumentTypeRequired),
    })
    .test('instrument-type-test', errorMessages.onlyGeneralAllowed, function (type) {
      const {audience, isGeneralInstrument} = this.parent;

      if (!audience || isGeneralInstrument) {
        return true;
      }

      return !(audience !== audienceStudentId && type !== typeFeedbackId);
    }),
  [FormNameEnum.instrumentSubType]: Yup.number()
    .nullable()
    .when(FormNameEnum.isGeneralInstrument, {
      is: true,
      then: Yup.number(),
      otherwise: Yup.number().nullable(),
    })
    .test('instrument-sub-type-test', errorMessages.subTypeRequired, function () {
      const {type, subType, isGeneralInstrument} = this.parent;
      const isMasterInstrument = !isGeneralInstrument;
      const hasType = !!type;
      const hasSubType = !!subType;

      if (isMasterInstrument) {
        const isPreOrPostSession = hasType && checkIfTypeStartsWithPreOrPostSessionFirstDigit(type?.toString());

        if (isPreOrPostSession) {
          return hasSubType;
        }
      }
      return true;
    }),
  [FormNameEnum.audience]: Yup.number()
    .nullable()
    .when(FormNameEnum.isGeneralInstrument, {
      is: true,
      then: Yup.number().notRequired(),
      otherwise: Yup.number().nullable().required(errorMessages.audienceRequired),
    }),
  [FormNameEnum.phase]: Yup.number()
    .nullable()
    .when(FormNameEnum.isGeneralInstrument, {
      is: true,
      then: Yup.number().notRequired(),
      otherwise: Yup.number().nullable().required(errorMessages.phaseRequired),
    }),
  [FormNameEnum.programs]: Yup.array()
    .of(Yup.number())
    .when(FormNameEnum.isGeneralInstrument, {
      is: true,
      then: Yup.array().of(Yup.number()).notRequired(),
      otherwise: Yup.array().of(Yup.number()).required(errorMessages.programRequired),
    }),
  [FormNameEnum.isGeneralInstrument]: Yup.boolean().notRequired(),
});
